import { Component, Input } from '@angular/core'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'
import { BreakValidationResult } from '../../model/break.model'

@Component({
  selector: 'hs-breaks-validation',
  templateUrl: './breaks-validation.component.html',
  styleUrls: ['./breaks-validation.component.scss'],
})
export class BreaksValidationComponent {
  @Input()
  validationResults: BreakValidationResult[] = []

  constructor(readonly activeModal: NgbActiveModal) {}

  onDismissModal() {
    this.activeModal.dismiss()
  }
}
